import { render, staticRenderFns } from "./CreateСategory.vue?vue&type=template&id=bcf3577a&"
import script from "./CreateСategory.vue?vue&type=script&lang=js&"
export * from "./CreateСategory.vue?vue&type=script&lang=js&"
import style0 from "./CreateСategory.vue?vue&type=style&index=0&id=bcf3577a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports